/*
 * @Author: your name
 * @Date: 2019-11-10 16:59:24
 * @LastEditTime: 2019-11-10 17:06:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\utility\common\fdsdf.js
 */
export class DateUtility {

    static getyyyyMMdd() {
        
        let date = new Date();
        
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let weekday = date.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (weekday < 10) {
            weekday = "0" + weekday;
        }
        return (year + "-" + month + "-" + weekday);
    }


    static getyyyyMMddhhmmss() {
        
        let date = new Date();
        
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let weekday = date.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (weekday < 10) {
            weekday = "0" + weekday;
        }
        
        
        let hour= date.getHours();
        if (hour < 10) {
            hour = "0" + hour;
        }

        let minutes = date.getMinutes();
        if (minutes < 10) {
            minutes = "0" + minutes;
        }

        let seconds = date.getSeconds();
        if (seconds < 10) {
            seconds = "0" + seconds;
        }

        return (year + "-" + month + "-" + weekday +" " + hour+":" +minutes +":" +seconds);
    }


    



}